import React from 'react';
import { Table } from 'antd';

interface AnnotationsListProps {
	columns: any[];
	annotations: any[];
}

const AnnotationsList: React.FC<AnnotationsListProps> = ({ columns, annotations }) => {
	const uniqueById = () => {
		const seen = new Set();
		return annotations.filter((item) => {
			if (seen.has(item.groupId ?? item.annotationId)) return false;
			seen.add(item.groupId ?? item.annotationId);
			return true;
		});
	};

	return (
		<div className="flex column" style={{ overflow: 'auto' }}>
			<Table
				columns={columns}
				dataSource={uniqueById()}
				locale={{
					emptyText: (
						<div className="flex column">
							<span>No data: Create some annotation</span>
						</div>
					),
				}}
			/>
		</div>
	);
};

export default AnnotationsList;
